module.exports = __webpack_public_path__ + "img/icon-whatsapp.aede9fa5.svg";